<template>
  <SplideSlide>
    <slot />
  </SplideSlide>
</template>

<script lang="ts">
export default { name: 'ProductGallerySelector' }
</script>

<script setup lang="ts">
import { SplideSlide } from '@splidejs/vue-splide'
</script>
